export const pluginsCopy = {
  tooltip: {
    promptLibrary: "Open your Prompt Library",
  },
};
